import { doc, getDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";

export type ProfileLite = {
  uid: string;
  username?: string | null;
  display_name?: string | null;
  displayName?: string | null;
  avatar_url?: string | null;
  photoURL?: string | null;
};

const cache = new Map<string, ProfileLite>();
const inflight = new Map<string, Promise<ProfileLite | null>>();

export function getCachedProfile(uid: string): ProfileLite | undefined {
  return cache.get(uid);
}

export async function fetchProfile(uid: string): Promise<ProfileLite | null> {
  if (!uid) return null;
  if (cache.has(uid)) return cache.get(uid)!;
  if (inflight.has(uid)) return inflight.get(uid)!;
  const p = (async () => {
    try {
      const snap = await getDoc(doc(db, "users", uid));
      const v = (snap.exists() ? (snap.data() as any) : {}) as any;
      const prof: ProfileLite = {
        uid,
        username: v.username ?? v.username_lower ?? null,
        display_name: v.display_name ?? v.displayName ?? null,
        displayName: v.displayName ?? v.display_name ?? null,
        avatar_url: v.avatar_url ?? v.photoURL ?? null,
        photoURL: v.photoURL ?? v.avatar_url ?? null,
      };
      cache.set(uid, prof);
      return prof;
    } catch {
      return null;
    } finally {
      inflight.delete(uid);
    }
  })();
  inflight.set(uid, p);
  return p;
}

export async function prefetchProfiles(uids: string[]) {
  const uniq = [...new Set(uids.filter(Boolean))];
  await Promise.all(uniq.map((u) => fetchProfile(u)));
}
